import { useSettingsStore } from '../stores';
import type { PluginOptions } from './type';
import { setCookie } from '../utils/cookie';
import { setEmpCode } from '../utils/auth';
import { getWujieOrQiankun } from '../utils/getWujieOrQiankun';
import { type CasLoginRes } from '../stores/modules/settings/types';
import { loginSuccess } from '../stores/loginSuccess';

const options: PluginOptions = {
  onVuePluginRegister: async ({ router }) => {
    const { bus } = await getWujieOrQiankun();

    const {
      settings: { login, casConfig },
    } = useSettingsStore();
    const loginTypeRes = typeof login.type === 'function' ? await login.type() : login.type;
    let userId = '';
    login?.onBeforeLogin?.(loginTypeRes);
    try {
      const checkTokenRes = await login?.onLogin?.(loginTypeRes, casConfig, router);
      userId = checkTokenRes?.userId || '';
      loginSuccess.value = true;

      let loginResCache: CasLoginRes | undefined;
      try {
        const cacheStr = window.localStorage.getItem(`CAS_LOGIN_RES__${casConfig.appKey}`);
        if (cacheStr) {
          loginResCache = JSON.parse(cacheStr);
        }
      } catch (e) {
        //
      }

      login?.onLoginSuccess?.(loginTypeRes, checkTokenRes, loginResCache);
      bus.$emit('loginSuccess',userId);
    } catch (e) {
      login?.onLoginFailed?.(loginTypeRes, e);
      bus.$emit('loginFailed', e);

      // cas登录失败后，会执行location跳转，但是在跳转之前，还会执行部分代码，导致后续产生少量401请求
      // 但在生产环境中，早班高峰时，因为一晚上没使用，token过期
      // 就会导致集中登录失败，从而导致401告警
      // 因此这里在捕获到错误后，直接向外抛出，阻塞后续进程执行
      if (loginTypeRes === 'cas') {
        throw e
      }
    }
    setEmpCode(userId);
    setCookie({
      name: 'userId',
      value: userId,
    });
  },
};

export default options;
